/** Shared search-param validator for routes that support highlight + chunkIndex. */
export function validateHighlightSearch(search: Record<string, unknown>): {
	highlight?: string;
	chunkIndex?: number;
} {
	return {
		highlight:
			typeof search.highlight === "string" ? search.highlight : undefined,
		chunkIndex:
			typeof search.chunkIndex === "number"
				? search.chunkIndex
				: undefined,
	};
}
